import { Component, OnInit, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppUrls } from '../../../utility/appurls';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskUtility } from '../../../utility/mask-utility';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-healthcare-provider-lookup-form',
  templateUrl: './healthcare-provider-lookup-form.component.html',
  styleUrls: ['./healthcare-provider-lookup-form.component.scss'],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HealthcareProviderLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  formLoaded = false;
  AppUrls = AppUrls;

  hpIdMaskConfig = MaskUtility.getEntityIdMask('HP');
  FieldLabelConstants = FieldLabelConstants;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService
      .getFormGroupForModel('healthcareProviderLookup')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.form = formInfo.formGroup;
        this.form.patchValue({ nameSearchOptionType: UserInputOptionType.StartsWith });
        this.formLoaded = true;
      });
  }

  search() {
    this.enterKey.emit();
  }

  public isValid(): boolean {
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.StartsWith,
    });
  }
}
